// extracted by mini-css-extract-plugin
export default {"moreButton":"eGAC3Y"};